import DenturesRFV from '@/assets/SVG/DenturesRFV';

import { reasonForVisitStyles } from './ReasonForVisit.styles';

export const Dentures = () => (
	<div
		style={
			{
				...reasonForVisitStyles.reasonForVisitIcon,
				...reasonForVisitStyles.reasonForVisitIconDentures,
			} as React.CSSProperties
		}
	>
		<DenturesRFV />
	</div>
);
